import { useFetch } from './useFetch';
import type { UtxoBlockResponse } from '../api/types';

export function useBlock(blockHash: string | undefined) {
  return useFetch<UtxoBlockResponse>(
    blockHash ? `/utxo/block/${blockHash}` : null
  );
}
